import moment from "moment";
import { UploadedFile } from "../../types/uploaded-file";
import { ContactServiceState } from "./types";
import { v4 as uuidv4 } from "uuid";

export const mapApiInsertedFile = (payload: unknown): UploadedFile => {
  return {
    id: +payload["id"],
    name: payload["name"],
    docDef: payload["docDef"],
    claimId: +payload["claimId"],
    type: payload["type"],
    addedDate: payload["addedDate"] && moment(payload["addedDate"]).toDate(),

    addedBy: payload["added_by"] ?? "CP2.0",

    ...(payload["claimItemsDamageAreasId"] && {
      cliamItemDamageId: +payload["claimItemsDamageAreasId"],
    }),
    ...(payload["claimItemsId"] && { claimItemsId: +payload["claimItemsId"] }),
  };
};

export const setCookie = (
  cname: string,
  data: string | object,
  { expireDays = 1, parseJson = false } = {}
) => {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${
    parseJson ? JSON.stringify(data) : data
  };${expires};path=/contact-service`;
};

export const getCookie = (cname: string): string => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trimStart();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const clearCookie = (cname) => {
  document.cookie = cname + "=; Max-Age=-99999999;path=/contact-service;";
};

const makeHTMLImageContent = (data) => {
  return `<div style="display: flex; flex-wrap: wrap; gap: 1rem;">${data
    .map((url) => {
      const isPdf = url.endsWith(".pdf");
      return `<div style="display: flex; align-items: center;"> <a href="${url}" target="_blank" style="display: inline-block;margin:5px"> ${
        isPdf
          ? `<img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" alt="PDF Icon" style="width: 75px; height: 75px; object-fit: contain;" />`
          : `<img src="${url}" alt="Image" style="width: 75px; height: 75px; object-fit: cover; border: 1px solid #d3d3d3; border-radius: 0.25rem;" />`
      } </a> </div>`;
    })
    .join("")} </div>`;
};

export const makeHTMLContentForTicket = (data: ContactServiceState): string => {
  const labels = {
    name: "Name on invoice",
    email: "Email",
    phone: "Phone",
    address: "Address",
    city: "City",
    state: "State",
    zip_code: "Zip Code",
    invoice: "Invoice",
    date_of_purchase: "Date of Purchase",
    store_name: "Store Name",
    store_phone: "Store Phone",
    store_address: "Store Address",
    store_city: "Store City",
    store_state: "Store State",
    were_any_items_exchanged: "Were any items exchanged",
    store_zip: "Store Zip code",
  };

  return ` <div style="background-color: rgba(243, 248, 254, 0.4); padding: 0.5rem; border-radius: 0.5rem; overflow: hidden;"> <table style="width: 100%; border-collapse: collapse;"> <tbody> <tr> <th colspan="2" style="color: rgb(0, 0, 0); padding: 0.5rem; border-bottom: 1px solid rgb(0, 0, 0); font-size: 18px; background: #cadeff;"> Customer Details </th> </tr> ${Object.entries(
    data.customerDetails
  )
    .map(
      ([key, value]) =>
        ` <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-top: 1px solid #d3d3d3; width:200px;"> ${labels[key]} </td> <td style="padding: 0.5rem; border-top: 1px solid #d3d3d3;"> ${value} </td> </tr>`
    )
    .join(
      ""
    )} </tbody> </table> <table style="width: 100%; border-collapse: collapse;"> <tbody> <tr> <th colspan="2" style="color: rgb(0, 0, 0); padding: 0.5rem; border-bottom: 1px solid rgb(0, 0, 0); font-size: 18px; background: #cadeff;"> Purchase Details </th> </tr> ${Object.entries(
    data.purchaseDetails
  )
    .map(
      ([key, value]) =>
        ` <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-top: 1px solid #d3d3d3; width:200px;"> ${labels[key]} </td> <td style="padding: 0.5rem; border-top: 1px solid #d3d3d3;"> ${value} </td> </tr>`
    )
    .join(
      ""
    )} </tbody> </table> <table style="width: 100%; border-collapse: collapse;"> <tbody> <tr> <th colspan="2" style="color: rgb(0, 0, 0); padding: 0.5rem; border-bottom: 1px solid rgb(0, 0, 0); font-size: 18px; background: #cadeff;"> Documents </th> </tr> ${Object.entries(
    data?.documents || []
  )
    .map(
      ([key, value = []]) =>
        ` <tr> <td style="color: #000; font-weight: 500; padding: 0.5rem; border-top: 1px solid #d3d3d3; width:200px;"> ${
          labels[key]
        } </td> <td style="padding: 0.5rem; border-top: 1px solid #d3d3d3;"> ${makeHTMLImageContent(
          value || []
        )} </td> </tr>`
    )
    .join("")} </tbody> </table> </div>`;
};

export function getFolderName() {
  let foldername: string = getCookie("foldername").toString();
  if (!foldername) {
    const uuid = uuidv4();
    const numericPart = uuid.replace(/-/g, "").slice(0, 15);
    foldername = parseInt(numericPart, 16).toString();
    setCookie("foldername", foldername);
  }
  return foldername;
}
